/* Evotrex Referral & Rewards: marketing interactions only. No API calls or point mutations. */
(() => {
  'use strict';
  if (window.__evotrexRewardsInstalled) return;
  window.__evotrexRewardsInstalled = true;

  function initialize(root) {
    if (!root || root.dataset.evrInitialized === 'true') return;
    root.dataset.evrInitialized = 'true';
    root.querySelectorAll('.faq-item button').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.faq-item');
        const panel = item.querySelector('.faq-panel');
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        item.classList.toggle('is-open', open);
        if (panel) panel.hidden = !open;
      });
    });

    const menuButton = root.querySelector('[data-evr-menu]');
    const mobileNav = root.querySelector('[data-evr-mobile-nav]');
    const menuIcon = root.querySelector('[data-evr-menu-icon]');
    const originalIcon = menuIcon ? menuIcon.innerHTML : '';
    function setMenu(open, returnFocus) {
      if (!menuButton || !mobileNav) return;
      mobileNav.hidden = !open;
      mobileNav.classList.toggle('is-open', open);
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      if (menuIcon) menuIcon.innerHTML = open ? '<path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>' : originalIcon;
      if (returnFocus) menuButton.focus();
    }
    if (menuButton) menuButton.addEventListener('click', () => setMenu(menuButton.getAttribute('aria-expanded') !== 'true', false));
    if (mobileNav) mobileNav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false, false)));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menuButton && menuButton.getAttribute('aria-expanded') === 'true') setMenu(false, true);
    });
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-evotrex-rewards]')) initialize(scope);
    scope.querySelectorAll('[data-evotrex-rewards]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
